import React, { useEffect, useState } from 'react'

interface AnimatedTextProps {
  phrases: string[]
  className?: string
  duration?: number // duration in seconds for each phrase
}

export const AnimatedText: React.FC<AnimatedTextProps> = ({
  phrases,
  className = '',
  duration = 8, // default 8 seconds per phrase
}) => {
  const [activeIndex, setActiveIndex] = useState(-1)
  const initialDelay = 1000 // 1 second before first phrase
  const phraseDelay = duration * 1000 + 2000 // duration + 2 second gap

  useEffect(() => {
    let timeoutId: NodeJS.Timeout

    const showNextPhrase = (index: number) => {
      if (index >= phrases.length) {
        // Reset to beginning
        setActiveIndex(-1)
        timeoutId = setTimeout(() => showNextPhrase(0), initialDelay)
        return
      }

      setActiveIndex(index)
      timeoutId = setTimeout(() => showNextPhrase(index + 1), phraseDelay)
    }

    // Start the sequence
    timeoutId = setTimeout(() => showNextPhrase(0), initialDelay)

    return () => {
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [phrases.length, duration])

  return (
    <div
      className={`animated-text-container ${className}`}
      style={{ '--animation-duration': `${duration}s` } as React.CSSProperties}
    >
      {phrases.map((phrase, index) => (
        <div key={index} className={`animated-phrase ${activeIndex === index ? 'active' : ''}`}>
          {phrase}
        </div>
      ))}
    </div>
  )
}
